import React, {ReactNode} from "react";

type Props = {
    size?: 'sm'|'lg',
    children: ReactNode,
    onClose?: () => void,
}

export function Modal({ size, children, onClose }: Props) {
    return <div className={'modal active' + (size !== undefined ? ' modal-' + size : '')}>
        <a onClick={() => onClose?.()} className="modal-overlay" aria-label="Close"></a>
        <div className="modal-container">
            {children}
        </div>
    </div>
}
